import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Typography } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';

import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import Menu from './menu';
import SignInButton from '../signin/mobile';
import './style.css';

type Props = {
    ActiveMenu: string,
};

function MobileMenu(props: Props) {
    const { ActiveMenu } = props;
    const [open, setOpen] = React.useState(false);

    const handleDrawerOpen = () => {
        setOpen(true);
    };
    const handleDrawerClose = () => {
        setOpen(false);
    };
    return (
        <Typography component="div" className="mobile-view">
            <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="end"
                onClick={handleDrawerOpen}
                className={clsx(open)}
            >
                <MenuIcon />
            </IconButton>
            <Drawer
                className="mobile-view-container"
                variant="persistent"
                anchor="right"
                open={open}
            >
                <div className="menu-close">
                    <IconButton onClick={handleDrawerClose}>
                        <CloseIcon />
                    </IconButton>
                </div>
                <Menu ActiveMenu={ActiveMenu} />
                <SignInButton />
            </Drawer>
        </Typography>
    );
}
MobileMenu.propTypes = {
    ActiveMenu: PropTypes.string,
};
export default MobileMenu;
